const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Sobre mí",
      projects: "Sitios Web",
      coordination: "Coordinación",
      langToggle: "EN",
    },
    meta: {
      home: {
        title: "Mariana Ramírez | Desarrolladora Web",
        description:
          "Desarrolladora web freelance y coordinadora de proyectos en México. Creo sitios con React y SEO, y coordino proyectos para que nada se pierda.",
      },
      about: {
        title: "Sobre mí | Mariana Ramírez — Desarrolladora Web",
        description:
          "Conoce a Mariana Ramírez, desarrolladora web freelance en México disponible para proyectos remotos en el extranjero, con experiencia en gestión de proyectos.",
      },
      projects: {
        title: "Sitios Web | Mariana Ramírez — Desarrolladora Web",
        description:
          "Casos de sitios web para negocios en México y el extranjero, y proyectos técnicos de Mariana Ramírez: React, SEO, diseño responsive y más.",
      },
      coordination: {
        title: "Coordinación de Proyectos | Mariana Ramírez",
        description:
          "Cómo pienso y cómo trabajo cuando coordino un proyecto: comunicación clara, documentación y herramientas digitales al servicio del equipo.",
      },
    },
    hero: {
      titleLead: "Sitios web que venden.",
      titleHighlight: "Proyectos que sí llegan a la meta.",
      subtitle:
        "Desarrolladora web y coordinadora de proyectos, con 8 años liderando personas y procesos.",
      ctaQuote: "Cotiza tu proyecto",
      ctaProjects: "Ver proyectos",
      photoAlt: "Mariana Ramírez, desarrolladora web",
    },
    services: {
      sectionTitle: "Servicios",
      items: [
        {
          title: "Sitios web para negocios",
          description:
            "Creo sitios que hacen que tu negocio se vea profesional y que tus clientes te encuentren. Desde una landing page hasta un sitio de varias páginas, con diseño responsive y optimización para Google (SEO).",
          features: [
            "Diseño a la medida",
            "Versión para celular",
            "SEO básico",
            "Dominio y publicación",
          ],
          deliveryNote: "Primer borrador listo en máximo 2 semanas.",
        },
        {
          eyebrow: "¿Tu proyecto necesita más que código?",
          title: "Coordinación y seguimiento de proyectos",
          description:
            "¿Tienes un proyecto que se te está desordenando? Llevo los tiempos, coordino a las personas y proveedores, y me aseguro de que nada se pase, para que tú te enfoques en tu negocio.",
          features: [
            "Seguimiento de tareas y tiempos",
            "Coordinación de personas y proveedores",
            "Reportes de avance",
          ],
          workNoteLink: "Así trabajo →",
        },
      ],
      guarantee: "Hago todos los ajustes necesarios hasta que quedes satisfecho con el resultado final.",
      remoteNote: "Trabajo 100% remoto — con clientes en México y el extranjero.",
      ctaBtn: "Cotiza tu proyecto",
    },
    projectsSection: {
      pageHeading: "Sitios Web de Mariana Ramírez",
      featuredTitle: "Sitios Web destacados",
      moreTitle: "Más sitios web",
      viewAllBtn: "Ver todos los sitios web",
      visit: "VISITAR",
      screenshotOf: "Captura de pantalla del proyecto",
    },
    notes: {
      sectionTitle: "Notas destacadas",
      viewAllBtn: "Ver todas las notas",
      pageTitle: "Coordinación de proyectos",
      pageSubtitle:
        "Así pienso y así trabajo cuando coordino un proyecto, de cualquier tamaño y en cualquier sector.",
      readMore: "Leer más",
      readLess: "Leer menos",
    },
    about: {
      greeting: "¡Hola! Soy",
      greetingName: "Mar",
      p1:
        "Estudié psicología, y ahí descubrí lo que más me gusta: entender qué necesitan las personas para que las cosas funcionen. Pasé 8 años en Recursos Humanos liderando equipos y construyendo procesos, aprendiendo a cambiar operaciones que solo apagaban fuegos por sistemas que sí dejan espacio para crecer.",
      p2:
        "En 2025 decidí sumar algo nuevo: aprendí a programar. No lo viví como un cambio de carrera, sino como una herramienta más para seguir haciendo lo que más me gusta: resolver problemas reales, ahora también con código.",
      p3:
        "Hoy esos años de experiencia siguen vivos en Marea People Partners, la consultora de RH que co-fundé con mi socia, donde ayudamos a empresas a encontrar estructura en medio del caos.",
      p4:
        "Y en paralelo, la programación se volvió parte de mi día a día: hoy construyo sitios web para negocios que quieren verse profesionales en línea, y coordino proyectos para que nada se pierda entre tiempos, personas y entregas. Es la misma capacidad de poner orden que aprendí liderando equipos, aplicada ahora a dos frentes distintos.",
      differentiator: "Entiendo los negocios porque yo también tengo los míos.",
      closing:
        "No prometo lo que no puedo cumplir, y cumplo lo que prometo. Si eso es lo que buscas para tu proyecto, hablemos.",
      downloadCv: "Descargar CV",
      techTitle: "Habilidades técnicas",
      softTitle: "Cómo trabajo",
      softSkills: [
        "Organizada y detallista",
        "Comunicación clara",
        "Gestión de tiempos y entregas",
        "Aprendizaje continuo",
        "Profesional y ética",
      ],
      eduTitle: "Educación y certificaciones",
      education: [
        { title: "Licenciatura en Psicología", institution: "ITESO", year: "2014 – 2019" },
        { title: "Comunicación Interna y Employee Experience", institution: "Eco Consultores", year: "2022" },
        { title: "Project Management (Básicos)", institution: "Coursera", year: "2023" },
        { title: "Desarrolladora Web", institution: "SheCodes", year: "2026" },
      ],
      toolsTitle: "Herramientas",
      workTogetherBtn: "Trabajemos juntas",
      photoAlt: "Mariana Ramírez, desarrolladora web en Guadalajara",
    },
    testimonials: {
      sectionTitle: "Lo que dicen mis clientes",
    },
    footer: {
      title: "Construyamos algo juntos",
      ctaBtn: "Escríbeme por WhatsApp",
      copy: "Construido con React · Publicado en Netlify",
      openSource: "Código abierto en",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      projects: "Websites",
      coordination: "Project Coordination",
      langToggle: "ES",
    },
    meta: {
      home: {
        title: "Mariana Ramírez | Web Developer",
        description:
          "Freelance web developer and project coordinator based in Mexico, working remotely worldwide. I build websites with React and SEO, and keep projects on track.",
      },
      about: {
        title: "About | Mariana Ramírez — Web Developer",
        description:
          "Meet Mariana Ramírez, a freelance web developer based in Mexico, available for remote projects worldwide, with a background in project management.",
      },
      projects: {
        title: "Websites | Mariana Ramírez — Web Developer",
        description:
          "Website case studies for businesses in Mexico and abroad, plus technical projects by Mariana Ramírez: React, SEO, responsive design, and more.",
      },
      coordination: {
        title: "Project Coordination | Mariana Ramírez",
        description:
          "How I think and how I work when coordinating a project: clear communication, documentation, and digital tools that actually serve the team.",
      },
    },
    hero: {
      titleLead: "Websites that sell.",
      titleHighlight: "Projects that actually cross the finish line.",
      subtitle:
        "Web developer and project coordinator, with 8 years leading people and processes.",
      ctaQuote: "Get a quote",
      ctaProjects: "View projects",
      photoAlt: "Mariana Ramírez, web developer",
    },
    services: {
      sectionTitle: "Services",
      items: [
        {
          title: "Business websites",
          description:
            "I build websites that make your business look professional and help customers find you — everything from a single landing page to a full multi-page site, with responsive design and SEO built right in.",
          features: [
            "Custom design",
            "Mobile-ready version",
            "Basic SEO",
            "Domain setup and deployment",
          ],
          deliveryNote: "First draft ready within 2 weeks.",
        },
        {
          eyebrow: "Need more than just code?",
          title: "Project coordination & tracking",
          description:
            "Is a project getting out of hand? I manage timelines, coordinate people and vendors, and make sure nothing falls through the cracks, so you can focus on running your business.",
          features: [
            "Task and timeline tracking",
            "Coordination of people and vendors",
            "Progress reports",
          ],
          workNoteLink: "See how I work →",
        },
      ],
      guarantee: "I'll make every adjustment needed until you're fully satisfied with the final result.",
      remoteNote: "100% remote — working with clients across Mexico and abroad.",
      ctaBtn: "Get a quote",
    },
    projectsSection: {
      pageHeading: "Mariana Ramírez's websites",
      featuredTitle: "Featured websites",
      moreTitle: "More websites",
      viewAllBtn: "View all websites",
      visit: "VISIT",
      screenshotOf: "Screenshot of the project",
    },
    notes: {
      sectionTitle: "Featured notes",
      viewAllBtn: "See all notes",
      pageTitle: "Project Coordination",
      pageSubtitle:
        "How I think and how I work when I'm coordinating a project — any size, any industry.",
      readMore: "Read more",
      readLess: "Show less",
    },
    about: {
      greeting: "Hi! I'm",
      greetingName: "Mar",
      p1:
        "I studied psychology, and that's where I discovered what I like most: understanding what people need to make things work. I spent 8 years in Human Resources leading teams and building processes, learning how to turn operations that only put out fires into systems that actually leave room to grow.",
      p2:
        "In 2025, I decided to add something new: I learned to code. I didn't experience it as a career change, but as another tool to keep doing what I like most: solving real problems, now with code too.",
      p3:
        "Today, those years of experience are still alive at Marea People Partners, the HR consulting firm I co-founded with my business partner, where we help companies find structure in the middle of chaos.",
      p4:
        "And in parallel, coding became part of my everyday work: today I build websites for businesses that want to look professional online, and I coordinate projects so nothing gets lost between timelines, people, and deliverables. It's the same knack for bringing order that I learned leading teams, now applied to two different fronts.",
      differentiator: "I understand businesses because I run my own, too.",
      closing:
        "I don't promise what I can't deliver, and I deliver what I promise. If that's what you're looking for in your project, let's talk.",
      downloadCv: "Download CV",
      techTitle: "Technical Skills",
      softTitle: "How I work",
      softSkills: [
        "Organized and detail-oriented",
        "Clear communication",
        "Timeline and delivery management",
        "Continuous learning",
        "Professional and ethical",
      ],
      eduTitle: "Education & Certifications",
      education: [
        { title: "Psychology Degree", institution: "ITESO", year: "2014 – 2019" },
        { title: "Internal Communication & Employee Experience", institution: "Eco Consultores", year: "2022" },
        { title: "Project Management (Basics)", institution: "Coursera", year: "2023" },
        { title: "Web Developer", institution: "SheCodes", year: "2026" },
      ],
      toolsTitle: "Tools",
      workTogetherBtn: "Let's work together",
      photoAlt: "Mariana Ramírez, web developer based in Guadalajara",
    },
    testimonials: {
      sectionTitle: "What my clients say",
    },
    footer: {
      title: "Let's build something together",
      ctaBtn: "Message me on WhatsApp",
      copy: "Built with React · Deployed on Netlify",
      openSource: "Open source on",
    },
  },
};

export default translations;
